import { inject, Injectable } from '@angular/core';
import type { FormArray, FormControl } from '@angular/forms';

import { ReorderLocationsFacade } from '@core/locations-legacy';

import { RequisitionFormManagerService } from '../../services/requisition-form-manager.service';

@Injectable()
export class ReorderLocationsRequisitionFacade extends ReorderLocationsFacade {
  private readonly requisitionFormManager = inject(RequisitionFormManagerService);

  public get locationsControl() {
    return <FormArray<FormControl>>this.requisitionFormManager.form.controls.locationIds!;
  }
}
